// Award
// Contract
export const factoryReduction = 'factoryReduction';
export const handSize1 = 'handSize1';
export const handSizeMinus3 = 'handSizeMinus3';
export const neighborFactoryEnergyColor = 'neighborFactoryEnergyColor';
export const noHandNextSeason = 'noHandNextSeason';
export const noWinterHand = 'noWinterHand';
export const noSummitCards = 'noSummitCards';
export const summitCarbonDump = 'summitCarbonDump';
export const recharge1 = 'recharge1';
export const takeNeighboringEnergy1 = 'takeNeighboringEnergy1';

// Equipment
export const animalFarm = 'animalFarm';
export const churchOfPseudoscience = 'churchOfPseudoscience';
export const coalDigger = 'coalDigger';
export const energyLeech = 'energyLeech';
export const hackingUsb = 'hackingUsb';
export const mulligan = 'mulligan';
export const polydactylism = 'polydactylism';
export const ravenousLawyers = 'ravenousLawyers';
export const recyclingPlant = 'recyclingPlant';
export const regulatoryCapture = 'regulatoryCapture';
export const selfImage = 'selfImage';
export const tieBreaker = 'tieBreaker';

// News
export const batteryReductionOneTurn = 'batteryReductionOneTurn';
export const factoryReductionOneTurn = 'factoryReductionOneTurn';
export const prReductionOneTurn = 'prReductionOneTurn';

// Summit
export const summitTypeTurn = 'turn';
export const summitTypeWinter = 'winter';

export const handSizePlus2 = 'handSizePlus2';
export const factoryHalfRoundedDown = 'factoryHalfRoundedDown';
export const factoryHalfRoundedUp = 'factoryHalfRoundedUp';

// Turn
export const carbonStolenThisTurn = 'carbonStolenThisTurn';
